export default __webpack_public_path__ + "static/media/video.154680d3.svg";